import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, MapPin, Package } from 'lucide-react';
interface HeroProps {
  onCTAClick: () => void;
}
export function Hero({
  onCTAClick
}: HeroProps) {
  return <section className="relative w-full min-h-screen flex items-center justify-center px-4 py-20 md:py-32" data-id="element-160">
      <div className="max-w-5xl mx-auto text-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-162">
          <div className="inline-block mb-8 px-6 py-3 bg-bg-card border border-border-card rounded-full text-sm md:text-base text-text-secondary" data-id="element-163">
            VOLEY 360 — Colección Completa del Entrenador
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black leading-tight mb-6" data-id="element-164">
            Todo tu año de vóley
            <br data-id="element-165" />
            <span className="text-orange" data-id="element-166">resuelto de una vez.</span>
          </h1>

          <p className="text-xl md:text-2xl text-text-secondary mb-12 font-medium" data-id="element-167">
            Sesiones · Técnica · Táctica · Drills · Planificación · Negocio
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-168">
            <div className="flex items-center gap-2 px-4 py-2 bg-bg-card border border-border-card rounded-lg" data-id="element-169">
              <FileText className="w-5 h-5 text-orange" data-id="element-170" />
              <span className="text-sm font-medium" data-id="element-171">PDF</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-bg-card border border-border-card rounded-lg" data-id="element-172">
              <Zap className="w-5 h-5 text-orange" data-id="element-173" />
              <span className="text-sm font-medium" data-id="element-174">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-bg-card border border-border-card rounded-lg" data-id="element-175">
              <Package className="w-5 h-5 text-orange" data-id="element-176" />
              <span className="text-sm font-medium" data-id="element-177">
                12 Tomos + 6 Bonus + 2 Élite
              </span>
            </div>
          </div>

          <motion.button onClick={onCTAClick} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block px-8 md:px-12 py-5 md:py-6 bg-orange text-white text-lg md:text-xl font-bold rounded-card shadow-2xl hover:bg-orange/90 transition-all mb-8" data-id="element-178">
            💪 QUIERO MI VOLEY 360 AHORA
          </motion.button>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-text-secondary" data-id="element-179">
            <div className="flex items-center gap-2" data-id="element-180">
              <span data-id="element-181">🛡️</span>
              <span data-id="element-182">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-183">
              <span data-id="element-184">🔒</span>
              <span data-id="element-185">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-186">
              <span data-id="element-187">💳</span>
              <span data-id="element-188">Tarjetas y transferencia</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}